import { observable } from 'mobx'

class Store {
  @observable visible = false

  setStoreData = params => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })
  }
}

export default Store
